import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store';

const getUnFormalizedZipState = (state: RootState) => state.unFormalizedZips;

export const unFormalizedZipSelectors = {
  getUnFormalizedZips: createSelector(
    getUnFormalizedZipState,
    (state) => state.unFormalizedZips,
  ),
  getUnFormalizedZipsLoading: createSelector(
    getUnFormalizedZipState,
    (state) => state.isLoading,
  ),
  getUnFormalizedZipDetail: createSelector(
    getUnFormalizedZipState,
    (state) => state.unFormalizedZipDetail.data,
  ),
  getUnFormalizedZipDetailLoading: createSelector(
    getUnFormalizedZipState,
    (state) => state.unFormalizedZipDetail.isLoading,
  ),
};
